import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  artistListState,
  bigQueryAccessTokenState,
  userListState,
} from "../../atom/atom";
import {
  fetchAndSetData,
  fetchArtistList,
  fetchUserList,
} from "../../api/fetch.api";
import { BigQueryResponse } from "../../types/bigQuery.type";
import axios, { AxiosError } from "axios";
import { endpoint, QUERY_ARTIST_USER_ID_LIST } from "../../module/bigQuery";
import ArtistUserCard from "../../components/pages/BigQuery/ArtistUserCard";
import { sendPushNotification } from "../../api/common.api";
import { ArtistUserGroups } from "../../components/pages/BigQuery/AutomatedProcess/type";
import {
  fetchRecentlyUpdatedArtists,
  formatLogData,
  groupUsersByArtist,
} from "../../components/pages/BigQuery/AutomatedProcess/util";
import AutomatedProcess from "../../components/pages/BigQuery/AutomatedProcess";

const BigQueryPage: React.FC = () => {
  const [logResult, setLogResult] = useState<any>();
  const [artistUserGroups, setArtistUserGroups] = useState<ArtistUserGroups>(
    {}
  );
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const [totalArtistList, setTotalArtistList] = useRecoilState(artistListState);
  const [totalUserList, setTotalUserList] = useRecoilState(userListState);
  const bigQueryAccessToken = useRecoilValue(bigQueryAccessTokenState);

  useEffect(() => {
    if (totalArtistList.length === 0)
      fetchAndSetData(fetchArtistList, setTotalArtistList);
  }, [totalArtistList.length]);

  useEffect(() => {
    if (totalUserList.length === 0)
      fetchAndSetData(fetchUserList, setTotalUserList);
  }, [totalUserList.length]);

  const onPress빅쿼리테스트 = async () => {
    const fetchData = async (accessToken: string) => {
      setIsLoading(true);
      setProgress(0);
      try {
        // Progress simulation
        const progressInterval = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 90) {
              clearInterval(progressInterval);
              return 90;
            }
            return prev + 10;
          });
        }, 1000);

        const response: BigQueryResponse = await axios.post(
          endpoint,
          { query: QUERY_ARTIST_USER_ID_LIST, useLegacySql: false },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        clearInterval(progressInterval);
        setProgress(100);
        setLogResult(response.data.rows);
        console.log("response : ", response);
      } catch (err: any) {
        console.error(err.message);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
          setProgress(0);
        }, 1000);
      }
    };

    if (bigQueryAccessToken) fetchData(bigQueryAccessToken);
  };

  useEffect(() => {
    if (logResult) {
      const formattedData = formatLogData(logResult);
      const groups = groupUsersByArtist(formattedData);
      setArtistUserGroups(groups);
    }
  }, [logResult]);

  useEffect(() => {
    const test = async () => {
      const response = await fetchRecentlyUpdatedArtists();
      console.log(response);
    };
    test();
  }, []);

  const handleProcessArtistUserList = async ({
    artistId,
    userIdList,
  }: {
    artistId: string;
    userIdList: string[];
  }) => {
    console.log(`Processing artist ${artistId} with users:`, userIdList);

    const selectedArtist = totalArtistList.find((a) => a.artistId === artistId);
    if (!selectedArtist) return window.alert("해당 아티스트가 없습니다.");

    const tokens = userIdList
      .map((userId) => {
        const user = totalUserList.find((u) => u.userId === userId);
        return user ? user.fcmToken : null;
      })
      .filter((token) => token !== null) as string[];

    if (tokens.length === 0) {
      console.log("No tokens found for users.");
      return;
    }

    const notificationData = {
      title: `${selectedArtist.artistName} 곡 업데이트`,
      body: `새로운 곡이 추가되었어요. 지금 바로 확인해보세요!`,
      tokenList: tokens,
      data: {
        songTitle: "New Release",
        screen: "Recent",
        type: "곡업데이트",
        songId: "0",
      },
    };

    try {
      await sendPushNotification(notificationData);
      console.log(`Notification sent to users of artist ${artistId}`);
    } catch (error) {
      console.error("Failed to send push notification:", error);
    }
  };

  const handleBulkSendNotifications = async () => {
    for (const [artistId, userIdList] of Object.entries(artistUserGroups)) {
      await handleProcessArtistUserList({ artistId, userIdList });
    }
  };

  return (
    <div>
      <h1>빅쿼리 실행 및 알림전송 페이지</h1>
      <AutomatedProcess setLogResult={setLogResult} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        {/* <button onClick={onPress빅쿼리테스트} disabled={isLoading}>
          {isLoading
            ? "데이터 로딩 중..."
            : "bigQuery api 실행하기 (이거 누르면 유저데이터 읽어옴. 10초 소요)"}
        </button> */}
      </div>

      {isLoading && (
        <div style={{ marginTop: "16px" }}>
          <div
            style={{
              width: "100%",
              height: "20px",
              backgroundColor: "#eee",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                backgroundColor: "#007bff",
                transition: "width 0.3s ease-in-out",
              }}
            />
          </div>
          <p style={{ textAlign: "center", marginTop: "8px" }}>
            {progress}% 완료
          </p>
        </div>
      )}

      <div style={{ marginTop: "32px" }}>
        <h2
          style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "16px" }}
        >
          Artist-User Groups
        </h2>

        <div>
          {Object.entries(artistUserGroups).map(([artistId, userIdList]) => {
            const artist = totalArtistList.find((a) => a.artistId === artistId);
            return (
              <ArtistUserCard
                key={artistId}
                artist={artist}
                userIdList={userIdList}
                onProcessUsers={handleProcessArtistUserList}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BigQueryPage;
